import { Injectable } from '@angular/core';
import { FilterGroup } from '@vendasta/va-filter2';
import { ColumnOrganizerType, ColumnType, TableDefinition } from '@vendasta/va-filter2-table';
import { VA_TABLE_DEFAULT_LABELS } from './va-table-labels';
import { ButtonsColumnComponent } from './columns/buttons-column.component';

@Injectable()
export class AuxiliaryDataTableFilterService {
  filters: FilterGroup = new FilterGroup('auxiliary-data');
}

const AUXILIARY_DATA_TABLE_DEF: TableDefinition = {
  id: 'custom-fields',
  columns: [
    {
      id: 'name',
      displayName: 'COMMON.AUXILIARY_DATA.SCHEMA.NAME',
      field: 'name',
      translateCell: true,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      id: 'description',
      displayName: 'COMMON.AUXILIARY_DATA.SCHEMA.DESCRIPTION',
      field: 'description',
      translateCell: true,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      id: 'type',
      displayName: 'COMMON.AUXILIARY_DATA.SCHEMA.TYPE',
      field: 'type',
      translateCell: true,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      cellComponent: ButtonsColumnComponent,
      id: 'buttons',
      displayName: '',
      field: 'id',
    },
  ],
  columnOrganizerType: ColumnOrganizerType.ADVANCED_ORGANIZER,
  options: {
    selectableRows: false,
  },
  labels: VA_TABLE_DEFAULT_LABELS,
};

export const tableDefinitionFactory = (filterService: AuxiliaryDataTableFilterService) => {
  const tableDefinition = AUXILIARY_DATA_TABLE_DEF;
  tableDefinition.filters = filterService.filters;
  return tableDefinition;
};
